import OrderDetailContent, { OrderDetailProps } from '@views/OrderDetail/OrderDetailContent';
import React from 'react';

const OrderDetail = (props: OrderDetailProps) => (
  <div className="px-4">
    <div className="max-w-4xl mx-auto">
      <OrderDetailContent {...props} trackOrderDetail />
    </div>
  </div>
);

export default OrderDetail;
